import { Info } from "lucide-react";

/**
 * The feedback-build disclosure. Required on every marketplace surface so nobody
 * mistakes seeded demo auctions or claimed metrics for verified inventory.
 */
export const SampleBanner = ({ className = "" }) => (
    <div
        data-testid="market-sample-banner"
        className={`flex items-start sm:items-center gap-2 rounded-lg border border-heat/40 bg-heat/10 px-3 py-2 text-xs sm:text-sm text-heat ${className}`}
    >
        <Info className="h-4 w-4 shrink-0 mt-0.5 sm:mt-0" />
        <span>Sample data for feedback. Stats marked claimed until verified.</span>
    </div>
);